<app-dataview-component [config]="dataViewConfig"
                        [rows]="dataViewRow" />
